<template>
    <div class="background rounded-lg">
        <Block v-if="loading" />
        <div>
                <div class="row">
                    <div class="col-12 p-2">
                        <VersatileFilter class="pt-3" 
                            advancedFilter 
                            :search="search" 
                            hideSearchField 
                            disableDates
                            @emptyFilter="clearFilter" 
                            :key="Reloadfilter" 
                            :enableDateStatus="true"
                            :columnfilterEndpoint="getData" 
                            :columnsSearch.sync="columsConfig">
                            <div class="px-2 pb-4">
                                <v-expansion-panels
                                    v-model="summaryPanel"
                                    accordion
                                    flat
                                    class="kardex-summary-panels"
                                >
                                    <v-expansion-panel>
                                        <v-expansion-panel-header class="kardex-summary-panel__header">
                                            <div>
                                                <div class="kardex-summary__title">Resumen general</div>
                                                <div class="kardex-summary__subtitle">
                                                    {{ reportsData.length ? 'Totales calculados sobre todos los registros filtrados.' : 'Sin registros para el período y filtros seleccionados.' }}
                                                </div>
                                            </div>
                                            <template #actions>
                                                <div class="kardex-summary-panel__actions">
                                                    <v-btn
                                                        class="btn-save kardex-summary-panel__export-btn"
                                                        :loading="loading"
                                                        :disabled="loading"
                                                        small
                                                        @click.stop.prevent="onExportPdfClick"
                                                    >
                                                        Exportar PDF
                                                    </v-btn>
                                                    <v-icon color="#475569" class="kardex-summary-panel__chevron">
                                                        mdi-chevron-down
                                                    </v-icon>
                                                </div>
                                            </template>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <div class="kardex-summary">
                                                <v-row class="kardex-summary-grid">
                                                    <v-col
                                                        v-for="card in kardexSummaryCards"
                                                        :key="card.label"
                                                        cols="12"
                                                        sm="6"
                                                        lg="3"
                                                        class="kardex-summary-grid__col"
                                                    >
                                                        <div class="kardex-summary-card">
                                                            <div class="kardex-summary-card__label">{{ card.label }}</div>
                                                            <div class="kardex-summary-card__value">{{ card.value }}</div>
                                                            <div v-if="card.secondary" class="kardex-summary-card__secondary">{{ card.secondary }}</div>
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </div>
                            <div class="px-2 pb-2">
                                <v-checkbox
                                    v-model="horizontalPdfFormat"
                                    class="mt-0 pt-0 kardex-horizontal-checkbox"
                                    dense
                                    hide-details
                                    label="Usar formato horizontal para totales en PDF"
                                />
                            </div>
                            <DxDataGrid 
                                ref="gridRef"
                                :data-source="reportsData"
                                :show-borders="true"
                                :column-auto-width="true"
                                @exporting="onExporting"
                                style="max-height: 600px;"
                                :paging="{ enabled: false }"
                                :columns="columns"
                                :grouping="{ autoExpandAll: true }"
                                :group-panel="{ visible: false }"
                                :show-column-headers="true"
                                :sorting="{ mode: 'none' }"
                            >
                                <template #groupKardexTemplate="{ data }">
                                    <div class="kardex-group-header">
                                        <div class="kardex-group-header__line">
                                            <span class="kardex-group-header__label">Cod.:</span>
                                            <span>{{ getKardexGroupData(data).idItem }}</span>
                                        </div>
                                        <div class="kardex-group-header__line">
                                            <span class="kardex-group-header__label">Almacén:</span>
                                            <span>{{ getKardexGroupData(data).almacen }}</span>
                                        </div>
                                        <div class="kardex-group-header__line">
                                            <span class="kardex-group-header__label">Producto:</span>
                                            <span>{{ getKardexGroupData(data).nombre }}</span>
                                        </div>
                                    </div>
                                </template>
                                <DxScrolling row-rendering-mode="virtual" showScrollbar="always" useNative="false" />
                                <DxExport :enabled="true" :formats="['xlsx']" />
                                <DxColumnChooser 
                                    :enabled="true" 
                                    mode="select" 
                                    title="Columnas visibles" 
                                    :height="400"
                                    :width="400" />
                                <DxStateStoring
                                    :enabled="true"
                                    type="localStorage"
                                    storage-key="conf_complete_kardex_grid_v2"
                                />
                            </DxDataGrid>
                        </VersatileFilter>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
import Block from '@/components/Block.vue';
import VersatileFilter from '@/components/VersatileFilter';
import { 
    DxDataGrid, 
   // DxColumn, 
    DxExport, 
    DxScrolling, 
    DxColumnChooser,
    DxStateStoring, 
} from 'devextreme-vue/data-grid';
import { numberWithCommas } from '@/helpers/money';
import { printToExcel } from "@/helpers/printToexcel";
import moment from "moment"
export default {
    name: "CompleteKardex",
    components: {
        VersatileFilter,
        DxDataGrid,
     //   DxColumn,
        DxExport,
        DxScrolling,
        Block,
        DxColumnChooser,
        DxStateStoring, 
    },
    props: ['win', 'datafilter'],
    data() {
        return {
            loading: false,
            search: {},
            filterWarehouses: {},
            horizontalPdfFormat: false,
            Reloadfilter: 0,
            summaryPanel: null,
            reportsData: [],
            columsConfig: [
                {//0
                    name: "date_start",
                    title: "Fecha inicio",
                    value: new Date().toLocaleDateString('es-ES', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    }),
                    type: "date"
                },
                {//1
                    name: "date_end",
                    title: "Fecha final",
                    value: new Date().toLocaleDateString('es-ES', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    }),
                    type: "date"
                },
                {//2
                    name: "column_Warehouse",
                    title: 'Almacen',
                    value: '',
                    type: 'select',
                    options: []
                },
                {//3
                    name: "ID_Item",
                    title: "ID Producto",
                    value: "",
                    type: "text",
                },
                {//4
                    name: "CodigoAlterno",
                    title: "Código Alterno",
                    value: "",
                    type: "text",
                },
                {//5
                    name: "ItemDescription",
                    title: "Nombre del producto",
                    value: "",
                    type: "text",
                },
                {//6
                    name: 'family',
                    title: 'Familía',
                    value: '',
                    type: 'select',
                    options: [],
                    onChange: this.getCategoriesByFamily,
                },
                {//7
                    name: 'category',
                    title: 'Categoría',
                    parent: 'family',
                    value: '',
                    type: 'select',
                    options: [],
                    onChange: this.getSubCategoriesByCat,
                },
                {//8
                    name: 'subcategory',
                    title: 'Subcategoría',
                    parent: 'category',
                    value: '',
                    type: 'select',
                    options: []
                },
                {//9
                    name: 'onlyWithMovements',
                    title: 'Mostrar solo con movimientos',
                    value: '1',
                    type: 'checkbox',
                },
            ],
            Currency: JSON.parse(localStorage.getItem('branch')).Currency,
            keymaster: JSON.parse(localStorage.getItem('user')).keymaster,
            showOptions: false,
            columnData:[],
            columns: [
                {
                    dataField: "kardexGroup",
                    caption: "Kardex",
                    visible: false,
                    hide: 1,
                    groupIndex: 0,
                    showWhenGrouped: false,
                    showInColumnChooser: false,
                    allowHiding: false,
                    groupCellTemplate: "groupKardexTemplate",
                },
                { dataField: "ID_Item", caption: "Cod.", visible: false, showWhenGrouped: false },
                { dataField: "almacen", caption: "Almacén", visible: false, showWhenGrouped: false },
                { dataField: "nombre", caption: "Producto", visible: false, showWhenGrouped: false },

                { dataField: "fecha", caption: "Fecha", visible: true, dataType: "date" },
                { dataField: "tipo", caption: "Tipo", visible: true },
                { dataField: "documento", caption: "Documento", visible: true },
                { dataField: "ProviderCustomer", caption: "Detalle", visible: true },

                { caption: "Entradas", visible: true, columns:[
                    { dataField: "cantidad_compra", caption: "Cant.", visible: true },
                    { dataField: "precio_compra", caption: "Costo Unit.", visible: true },
                    { dataField: "total_compra", caption: "Costo Total", visible: true },
                ]},

                { caption: "Salidas", visible: true, columns:[
                    { dataField: "cantidad_venta", caption: "Cant.", visible: true },
                    { dataField: "precio_venta", caption: "Unitario", visible: true },
                    { dataField: "total_venta", caption: "Total", visible: true },
                ]},
                { caption: "Saldo", visible: true, columns:[
                    { dataField: "saldo_cantidad", caption: "Cant.", visible: true },
                    { dataField: "costo_promedio", caption: "Costo Unit.", visible: true },
                    { dataField: "saldo_valor", caption: "Total", visible: true },
                ]},
            ],
        }
    },
    watch: {
    },
    computed:{
        groupedKardexData() {
            const groups = new Map();

            this.reportsData.forEach(row => {
                const groupKey = `${row.ID_Warehouse || ''}|||${row.ID_Item || ''}`;
                if (!groups.has(groupKey)) {
                    groups.set(groupKey, {
                        key: groupKey,
                        ID_Item: row.ID_Item || '',
                        nombre: row.nombre || '',
                        ID_Warehouse: row.ID_Warehouse || '',
                        Warehouse: row.Warehouse || row.almacen || '',
                        rows: [],
                    });
                }

                groups.get(groupKey).rows.push(row);
            });

            return Array.from(groups.values()).map(group => {
                const normalizedRows = this.normalizeGroupRows(group.rows);

                return {
                    ...group,
                    rows: normalizedRows,
                    finalBalance: this.getGroupFinalBalance(normalizedRows),
                };
            });
        },
        kardexSummary() {
            const summary = {
                totalGroups: this.groupedKardexData.length,
                initialBalanceQty: 0,
                initialBalanceValue: 0,
                totalEntriesQty: 0,
                totalEntriesValue: 0,
                totalOutputsQty: 0,
                totalOutputsValue: 0,
                finalBalanceQty: 0,
                finalBalanceValue: 0,
                averageCost: 0,
            };

            this.groupedKardexData.forEach(group => {
                const firstRow = group.rows[0] || {};
                summary.initialBalanceQty += this.toNumber(firstRow.saldo_cantidad);
                summary.initialBalanceValue += this.toNumber(firstRow.saldo_valor);
                summary.finalBalanceQty += this.toNumber(group.finalBalance.saldo_cantidad);
                summary.finalBalanceValue += this.toNumber(group.finalBalance.saldo_valor);
            });

            this.reportsData.forEach(row => {
                if (this.isInitialBalanceRow(row)) {
                    return;
                }

                summary.totalEntriesQty += this.toNumber(row.cantidad_compra);
                summary.totalEntriesValue += this.toNumber(row.total_compra);
                summary.totalOutputsQty += this.toNumber(row.cantidad_venta);
                summary.totalOutputsValue += this.toNumber(row.total_venta);
            });

            summary.averageCost = summary.finalBalanceQty
                ? summary.finalBalanceValue / summary.finalBalanceQty
                : 0;

            return summary;
        },
        kardexSummaryCards() {
            const summary = this.kardexSummary;

            return [
                {
                    label: 'Kardex consolidados',
                    value: this.formatSummaryCount(summary.totalGroups),
                    secondary: 'Productos / almacenes incluidos',
                },
                {
                    label: 'Saldo inicial general',
                    value: this.formatSummaryQuantity(summary.initialBalanceQty),
                    secondary: this.formatSummaryMoney(summary.initialBalanceValue),
                },
                {
                    label: 'Total entradas',
                    value: this.formatSummaryQuantity(summary.totalEntriesQty),
                    secondary: this.formatSummaryMoney(summary.totalEntriesValue),
                },
                {
                    label: 'Total salidas',
                    value: this.formatSummaryQuantity(summary.totalOutputsQty),
                    secondary: this.formatSummaryMoney(summary.totalOutputsValue),
                },
                {
                    label: 'Existencias actuales / saldo final',
                    value: this.formatSummaryQuantity(summary.finalBalanceQty),
                    secondary: 'Cantidad consolidada del inventario',
                },
                {
                    label: 'Inventario valorizado',
                    value: this.formatSummaryMoney(summary.finalBalanceValue),
                    secondary: `Costo promedio general: ${this.formatSummaryMoney(summary.averageCost)}`,
                },
            ];
        },
        kardexSummaryRowsForPdf() {
            const summary = this.kardexSummary;

            return [
                ['Kardex consolidados', this.formatSummaryCount(summary.totalGroups)],
                ['Saldo inicial general (cantidad)', this.formatSummaryQuantity(summary.initialBalanceQty)],
                ['Saldo inicial general (valor)', this.formatSummaryMoney(summary.initialBalanceValue)],
                ['Total entradas (cantidad)', this.formatSummaryQuantity(summary.totalEntriesQty)],
                ['Total entradas (valor)', this.formatSummaryMoney(summary.totalEntriesValue)],
                ['Total salidas (cantidad)', this.formatSummaryQuantity(summary.totalOutputsQty)],
                ['Total salidas (valor)', this.formatSummaryMoney(summary.totalOutputsValue)],
                ['Existencias actuales / saldo final', this.formatSummaryQuantity(summary.finalBalanceQty)],
                ['Inventario valorizado', this.formatSummaryMoney(summary.finalBalanceValue)],
                ['Costo promedio general', this.formatSummaryMoney(summary.averageCost)],
            ];
        },
    },
    async mounted() {
        this.setSegmentation();
        this.getWarehouse();
    },
    methods: {
        getSubCategoriesByCat(){
            const subcategories = this.datafilter.SubCategories || [];
            const categorySelected = this.columsConfig[7].value;
            this.columsConfig[8].value = "";
            this.columsConfig[8].options = subcategories.filter(element => element.parent_id === categorySelected);
            this.columsConfig[8].disabled = false;
            console.log(subcategories);
            
        },
        getCategoriesByFamily(){
            const categories = this.datafilter.Categories || [];
            const familySelected = this.columsConfig[6].value;
            this.columsConfig[7].value = "";
            this.columsConfig[8].value = "";
            this.columsConfig[7].options = categories.filter(element => {
                console.log(element.parent_id, familySelected);
                
                return element.parent_id === familySelected
            });
            this.columsConfig[7].disabled = false;
            this.columsConfig[8].disabled = true;
        },
        getByName(name) {
            return this.columnsConfig.findIndex(col => col.name === name);
        },
        getKardexGroupData(cellData) {
            return this.getKardexParts(cellData?.value || cellData?.displayValue || "");
        },
        getKardexParts(value) {
            const [idItem = "", almacen = "", nombre = ""] = String(value || "").split("|||");
            return { idItem, almacen, nombre };
        },
        updateForDataField(dataField, changes) {
            const update = (cols) => {
            return cols.map(col => {
                if (col.dataField === dataField) {
                    return {...col, ...changes };
                }
                if (col.columns) {
                    return { ...col, columns: update(col.columns) };
                }
                return col;
            });
            };
            this.columns = update(this.columns);
        },
        setColumnVisible(dataField, visible = false) {
            const grid = this.$refs.gridRef?.instance;
            if (!grid) return;

            grid.columnOption(dataField, "visible", visible);
            this.columns = this.columns.map(col => {
                if (col.dataField === dataField) {
                    return { ...col, visible };
                }
                return col;
            });
        },
        updateColumn(col) {
            const grid = this.$refs.gridRef.instance;
            grid.columnOption(col.dataField, "visible", col.visible);
        },
        setSegmentation(){
            const sortByName = (arr) => [...arr].sort((a, b) => (a?.name || '').localeCompare(b?.name || ''));
            this.columsConfig[6].options = sortByName(this.datafilter.Families);
            this.columsConfig[7].options = sortByName(this.datafilter.Categories);
            this.columsConfig[8].options = sortByName(this.datafilter.SubCategories);
            
        },
        getData(e) {
            this.loading = true;
            let params = {
                dateStart: this.columsConfig[0].value,
                dateEnd: this.columsConfig[1].value,
                warehouse: this.columsConfig[2].value || null,
                ID_Item: this.columsConfig[3].value || null,
                CodigoAlterno: this.columsConfig[4].value || null,
                ItemDescription: this.columsConfig[5].value || null,
                family: this.columsConfig[6].value || null,
                category: this.columsConfig[7].value || null,
                subcategory: this.columsConfig[8].value || null,
                onlyWithMovements: this.columsConfig[9].value && this.columsConfig[9].value != 0 ? 1 : 0,
            };

            if (e?.filter) {
                params.filter = e.filter;
            }

            return this.$API.inventoryReports.getCompleteKardex(params).then(response => {
                this.reportsData = response.data.map(element => {
                    return {
                        ...element,
                        almacen: element.Warehouse || "",
                        ingresos_netos: this.formatMoneyField(element.ingresos_netos),
                        kardexGroup: `${element.ID_Item || ""}|||${element.Warehouse || ""}|||${element.nombre || ""}`,
                    };
                });
            }).catch(error => {
                    console.log(error);
            }).finally(() => this.loading = false)
        },
        getWarehouse() {
            const warehouses = this.datafilter?.Warehouses || [];
            this.columsConfig[2].options = warehouses;                
        },
        clearFilter() {
            this.columsConfig[0].value = new Date().toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
            this.columsConfig[1].value = this.columsConfig[1].options[0];
            this.columsConfig[2].value = '5';
            this.reportsData = [];
        },
        formatMoneyField(value) {
            return `${this.Currency}${numberWithCommas(value)}`;
        },
        toNumber(value) {
            if (value === null || value === undefined || value === '') {
                return 0;
            }

            if (typeof value === 'number') {
                return Number.isFinite(value) ? value : 0;
            }

            const normalized = String(value).replace(/[^0-9.-]/g, '');
            const parsed = Number(normalized);
            return Number.isFinite(parsed) ? parsed : 0;
        },
        formatSummaryCount(value) {
            return this.toNumber(value).toLocaleString('es-SV', {
                maximumFractionDigits: 0,
            });
        },
        formatSummaryQuantity(value) {
            return this.toNumber(value).toLocaleString('es-SV', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
        formatSummaryMoney(value) {
            return `${this.Currency}${this.toNumber(value).toLocaleString('es-SV', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}`;
        },
        parseFilterDate(value) {
            if (!value) return null;
            if (moment.isMoment(value)) return value.clone();
            if (value instanceof Date) return moment(value);

            const parsed = moment(value, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);
            return parsed.isValid() ? parsed : null;
        },
        formatPeriodDate(value) {
            const parsed = this.parseFilterDate(value);
            return parsed?.isValid() ? parsed.format('DD/MM/YYYY') : '';
        },
        formatFileDate(value) {
            const parsed = this.parseFilterDate(value);
            return parsed?.isValid() ? parsed.format('YYYY-MM-DD') : 'sin-fecha';
        },
        formatPdfDate(value, fallback = '') {
            const parsed = this.parseFilterDate(value);
            return parsed?.isValid() ? parsed.format('DD/MM/YYYY') : fallback;
        },
        formatPdfText(value, fallback = '') {
            if (value === null || value === undefined) {
                return fallback;
            }

            const normalized = String(value).trim();
            if (!normalized || normalized === '-') {
                return fallback;
            }

            return normalized;
        },
        formatPdfNumber(value, options = {}) {
            const { fallback = '', decimals = 2, blankZero = true } = options;
            if (value === null || value === undefined || value === '') {
                return fallback;
            }

            const number = Number(value);
            if (Number.isNaN(number) || (blankZero && number === 0)) {
                return fallback;
            }

            return number.toLocaleString('es-SV', {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals,
            });
        },
        formatPdfMoney(value, options = {}) {
            const { fallback = '', decimals = 2, blankZero = true } = options;
            if (value === null || value === undefined || value === '') {
                return fallback;
            }

            const number = Number(value);
            if (Number.isNaN(number) || (blankZero && number === 0)) {
                return fallback;
            }

            return `${this.Currency}${number.toLocaleString('es-SV', {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals,
            })}`;
        },
        getOptionLabel(options = [], value, fallback = 'Todas') {
            if (value === null || value === undefined || value === '') {
                return fallback;
            }

            const option = options.find(item => String(item.value) === String(value));
            return option?.name || value || fallback;
        },
        getSelectedProductLabel() {
            const productFilters = [
                this.columsConfig[3].value ? `ID: ${this.columsConfig[3].value}` : null,
                this.columsConfig[4].value ? `Código alterno: ${this.columsConfig[4].value}` : null,
                this.columsConfig[5].value ? `Nombre: ${this.columsConfig[5].value}` : null,
            ].filter(Boolean);

            return productFilters.length ? productFilters.join(' | ') : 'Todos';
        },
        getCompanyName() {
            const branch = JSON.parse(localStorage.getItem('branch') || '{}');
            const user = JSON.parse(localStorage.getItem('user') || '{}');

            return branch.BusinessBillingName || branch.BusinessName || user.business || 'Empresa';
        },
        isInitialBalanceRow(row) {
            return String(row?.tipo || '').toLowerCase() === 'saldo inicial';
        },
        createSyntheticInitialBalanceRow(referenceRow) {
            return {
                ...referenceRow,
                SystemDateInsert: this.parseFilterDate(this.columsConfig[0].value)?.toISOString() || null,
                fecha: this.parseFilterDate(this.columsConfig[0].value)?.format('YYYY-MM-DD') || null,
                tipo: 'Saldo inicial',
                documento: null,
                ProviderCustomer: null,
                precio_compra: null,
                cantidad_compra: null,
                total_compra: null,
                cantidad_venta: null,
                precio_venta: null,
                total_venta: null,
                saldo_cantidad: 0,
                costo_promedio: 0,
                saldo_valor: 0,
                RowNo: 0,
            };
        },
        normalizeGroupRows(rows = []) {
            const sortedRows = [...rows].sort((left, right) => {
                const leftDate = this.parseFilterDate(left.SystemDateInsert || left.fecha)?.valueOf() || 0;
                const rightDate = this.parseFilterDate(right.SystemDateInsert || right.fecha)?.valueOf() || 0;

                if (leftDate !== rightDate) {
                    return leftDate - rightDate;
                }

                return Number(left.RowNo || 0) - Number(right.RowNo || 0);
            });

            const initialBalance = sortedRows.find(row => this.isInitialBalanceRow(row));
            const movementRows = sortedRows.filter(row => !this.isInitialBalanceRow(row));

            return [
                initialBalance || this.createSyntheticInitialBalanceRow(sortedRows[0] || {}),
                ...movementRows,
            ];
        },
        getGroupFinalBalance(rows = []) {
            const normalizedRows = this.normalizeGroupRows(rows);
            const lastRow = normalizedRows[normalizedRows.length - 1] || {};

            return {
                saldo_cantidad: this.toNumber(lastRow.saldo_cantidad),
                costo_promedio: this.toNumber(lastRow.costo_promedio),
                saldo_valor: this.toNumber(lastRow.saldo_valor),
            };
        },
        getGroupedKardexData() {
            return this.groupedKardexData;
        },
        getPdfTableHead() {
            return [
                [
                    { content: 'FECHA', rowSpan: 2, styles: { valign: 'middle' } },
                    { content: 'TIPO', rowSpan: 2, styles: { valign: 'middle' } },
                    { content: 'DOCUMENTO', rowSpan: 2, styles: { valign: 'middle' } },
                    { content: 'PROVEEDOR / CLIENTE', rowSpan: 2, styles: { valign: 'middle' } },
                    { content: 'ENTRADAS', colSpan: 3, styles: { halign: 'center' } },
                    { content: 'SALIDAS', colSpan: 3, styles: { halign: 'center' } },
                    { content: 'SALDOS', colSpan: 3, styles: { halign: 'center' } },
                ],
                [
                    'CANT.',
                    'P. COMPRA',
                    'TOTAL',
                    'CANT.',
                    'P. VENTA',
                    'TOTAL',
                    'CANT.',
                    'C. PROMEDIO',
                    'VALOR',
                ],
            ];
        },
        buildPdfGrandTotalInlineRow() {
            return [
                {
                    content: 'Total General:',
                    colSpan: 4,
                    styles: {
                        fontStyle: 'bold',
                        halign: 'right',
                    },
                },
                this.formatPdfNumber(this.kardexSummary.totalEntriesQty, { blankZero: false }),
                '',
                this.formatPdfMoney(this.kardexSummary.totalEntriesValue, { blankZero: false }),
                this.formatPdfNumber(this.kardexSummary.totalOutputsQty, { blankZero: false }),
                '',
                this.formatPdfMoney(this.kardexSummary.totalOutputsValue, { blankZero: false }),
                this.formatPdfNumber(this.kardexSummary.finalBalanceQty, { blankZero: false }),
                '',
                this.formatPdfMoney(this.kardexSummary.finalBalanceValue, { blankZero: false }),
            ];
        },
        buildPdfTableRows(group, options = {}) {
            const { appendGrandTotal = false } = options;
            const body = [];
            const rowMeta = [];

            group.rows.forEach(row => {
                const isInitialBalance = this.isInitialBalanceRow(row);

                body.push([
                    isInitialBalance ? this.formatPeriodDate(this.columsConfig[0].value) : this.formatPdfDate(row.SystemDateInsert || row.fecha),
                    isInitialBalance ? 'Saldo inicial' : this.formatPdfText(row.tipo),
                    isInitialBalance ? '' : this.formatPdfText(row.documento),
                    isInitialBalance ? '' : this.formatPdfText(row.ProviderCustomer),
                    isInitialBalance ? '' : this.formatPdfNumber(row.cantidad_compra),
                    isInitialBalance ? '' : this.formatPdfMoney(row.precio_compra),
                    isInitialBalance ? '' : this.formatPdfMoney(row.total_compra),
                    isInitialBalance ? '' : this.formatPdfNumber(row.cantidad_venta),
                    isInitialBalance ? '' : this.formatPdfMoney(row.precio_venta),
                    isInitialBalance ? '' : this.formatPdfMoney(row.total_venta),
                    this.formatPdfNumber(row.saldo_cantidad, { blankZero: false }),
                    this.formatPdfMoney(row.costo_promedio, { blankZero: false }),
                    this.formatPdfMoney(row.saldo_valor, { blankZero: false }),
                ]);
                rowMeta.push(isInitialBalance ? 'initial' : 'movement');
            });

            body.push([
                {
                    content: 'SALDO FINAL',
                    colSpan: 10,
                    styles: {
                        halign: 'right',
                        fontStyle: 'bold',
                        fillColor: [255, 255, 255],
                        textColor: [15, 23, 42],
                    },
                },
                this.formatPdfNumber(group.finalBalance.saldo_cantidad, { blankZero: false }),
                this.formatPdfMoney(group.finalBalance.costo_promedio, { blankZero: false }),
                this.formatPdfMoney(group.finalBalance.saldo_valor, { blankZero: false }),
            ]);
            rowMeta.push('summary');

            if (appendGrandTotal) {
                body.push(this.buildPdfGrandTotalInlineRow());
                rowMeta.push('grand-summary');
            }

            return { body, rowMeta };
        },
        drawGeneralPdfHeader(doc, context) {
            const { companyName, pageWidth, dateStart, dateEnd } = context;
            doc.setPage(1);
            doc.setTextColor(15, 23, 42);

            let y = 10;
            y += 7;
            doc.setFont(undefined, 'bold');
            doc.setFontSize(11);
            doc.text(companyName.toUpperCase(), pageWidth / 2, y, { align: 'center' });
            y += 5;
            doc.text('KARDEX GENERAL', pageWidth / 2, y, { align: 'center' });
            y += 5;
            doc.setFontSize(9);
            doc.text(`Del ${dateStart} al ${dateEnd}`, pageWidth / 2, y, { align: 'center' });
        },
        drawBlockHeader(doc, group, pageWidth, y) {
            doc.setTextColor(15, 23, 42);
            doc.setFont(undefined, 'bold');
            doc.setFontSize(8.5);
            doc.text(`${[group.ID_Item, group.nombre].filter(Boolean).join(' ')}`, pageWidth / 2, y, { align: 'center' });
            doc.text(`Bodega: ${group.Warehouse || ''}`, pageWidth / 2, y + 4, { align: 'center' });
            doc.setDrawColor(0, 0, 0);
            doc.setLineWidth(0.2);
            doc.line(8, y + 6.5, pageWidth - 8, y + 6.5);
        },
        async waitForLoadingOverlay() {
            await this.$nextTick();
            await new Promise(resolve => {
                requestAnimationFrame(() => {
                    requestAnimationFrame(resolve);
                });
            });
        },
        addPdfFooters(doc, companyName, generatedAt) {
            const pageCount = doc.internal.getNumberOfPages();
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();

            for (let page = 1; page <= pageCount; page++) {
                doc.setPage(page);
                doc.setDrawColor(203, 213, 225);
                doc.setLineWidth(0.2);
                doc.line(8, pageHeight - 10, pageWidth - 8, pageHeight - 10);
                doc.setFontSize(7.5);
                doc.setFont(undefined, 'normal');
                doc.setTextColor(71, 85, 105);
                doc.text(
                    `${companyName} | ${generatedAt} | Página ${page} de ${pageCount}`,
                    pageWidth / 2,
                    pageHeight - 6,
                    { align: 'center' }
                );
            }
        },
        getMinimumBlockStartHeight() {
            return 24;
        },
        getPdfSummaryTableHead() {
            return [['RESUMEN GENERAL', 'VALOR']];
        },
        isHighlightedPdfSummaryRow(label = '') {
            return [
                'Existencias actuales / saldo final',
                'Inventario valorizado',
            ].includes(label);
        },
        async exportPdfDetailedReport() {
            const { jsPDF } = await import('jspdf');
            const autoTable = (await import('jspdf-autotable')).default;

            const doc = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: 'letter',
                compress: true,
            });

            const companyName = this.getCompanyName();
            const generatedAt = moment().format('DD/MM/YYYY HH:mm:ss');
            const dateStart = this.formatPeriodDate(this.columsConfig[0].value);
            const dateEnd = this.formatPeriodDate(this.columsConfig[1].value);
            const groupedData = this.getGroupedKardexData();

            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            const marginLeft = 8;
            const marginRight = 8;
            const contentBottom = pageHeight - 16;
            const blockHeaderHeight = 10;
            const firstPageStartY = 36;
            const continuationTop = 20;
            let currentY = firstPageStartY;

            if (!groupedData.length) {
                doc.setFontSize(10);
                doc.setTextColor(71, 85, 105);
                doc.text('No hay registros para exportar en el período seleccionado.', marginLeft, currentY);
            }

            groupedData.forEach((group, index) => {
                const availableHeight = contentBottom - currentY;
                if (availableHeight < this.getMinimumBlockStartHeight()) {
                    doc.addPage();
                    currentY = 10;
                }

                const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
                this.drawBlockHeader(doc, group, pageWidth, currentY);

                const { body, rowMeta } = this.buildPdfTableRows(group, {
                    appendGrandTotal: this.horizontalPdfFormat && index === groupedData.length - 1,
                });
                autoTable(doc, {
                    startY: currentY + blockHeaderHeight,
                    margin: {
                        top: continuationTop,
                        right: marginRight,
                        bottom: 16,
                        left: marginLeft,
                    },
                    head: this.getPdfTableHead(),
                    body,
                    showHead: 'everyPage',
                    theme: 'grid',
                    rowPageBreak: 'auto',
                    tableWidth: pageWidth - marginLeft - marginRight,
                    styles: {
                        fontSize: 6,
                        cellPadding: 0.45,
                        minCellHeight: 4,
                        textColor: [15, 23, 42],
                        lineColor: [0, 0, 0],
                        lineWidth: 0,
                        overflow: 'hidden',
                        valign: 'middle',
                    },
                    headStyles: {
                        fillColor: false,
                        textColor: [0, 0, 0],
                        lineColor: [0, 0, 0],
                        fontStyle: 'bold',
                        halign: 'center',
                        valign: 'middle',
                    },
                    columnStyles: {
                        0: { cellWidth: 16, halign: 'left' },
                        1: { cellWidth: 18, halign: 'left' },
                        2: { cellWidth: 26, halign: 'left' },
                        3: { cellWidth: 63, halign: 'left' },
                        4: { cellWidth: 14, halign: 'right' },
                        5: { cellWidth: 15, halign: 'right' },
                        6: { cellWidth: 16, halign: 'right' },
                        7: { cellWidth: 14, halign: 'right' },
                        8: { cellWidth: 15, halign: 'right' },
                        9: { cellWidth: 16, halign: 'right' },
                        10: { cellWidth: 14, halign: 'right' },
                        11: { cellWidth: 16, halign: 'right' },
                        12: { cellWidth: 20, halign: 'right' },
                    },
                    didParseCell: (data) => {
                        if (data.section === 'head') {
                            data.cell.styles.textColor = [0, 0, 0];
                            return;
                        }

                        if (data.section !== 'body') {
                            return;
                        }

                        const meta = rowMeta[data.row.index];
                        if (meta === 'initial') {
                            data.cell.styles.fontStyle = 'bold';
                            if (data.column.index >= 4 && data.column.index <= 9) {
                                data.cell.styles.halign = 'center';
                            }
                        }

                        if (meta === 'summary' || meta === 'grand-summary') {
                            data.cell.styles.fontStyle = 'bold';
                            data.cell.styles.fillColor = [255, 255, 255];
                            data.cell.styles.textColor = [15, 23, 42];
                            data.cell.styles.halign = data.column.index >= 4 ? 'right' : 'right';
                            data.cell.styles.lineWidth = 0;

                            if (meta === 'grand-summary') {
                                data.cell.styles.lineWidth = {
                                    top: 0.2,
                                    right: 0,
                                    bottom: 0,
                                    left: 0,
                                };
                                data.cell.styles.lineColor = [0, 0, 0];
                            }
                        }
                    },
                    didDrawPage: () => {
                        const pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
                        if (pageNumber > currentPage) {
                            this.drawBlockHeader(doc, group, pageWidth, 10);
                        }
                    },
                });

                currentY = doc.lastAutoTable.finalY + 6;
            });

            if (!this.horizontalPdfFormat) {
                const summaryTitleY = currentY + 4;
                if ((contentBottom - summaryTitleY) < 40) {
                    doc.addPage();
                    currentY = 12;
                }

                doc.setTextColor(15, 23, 42);
                doc.setFont(undefined, 'bold');
                doc.setFontSize(9.5);
                doc.text('RESUMEN GENERAL', marginLeft, currentY + 4);
                doc.setFont(undefined, 'normal');
                doc.setFontSize(8);
                doc.text(`Período: Del ${dateStart} al ${dateEnd}`, marginLeft, currentY + 8);

                autoTable(doc, {
                    startY: currentY + 11,
                    margin: {
                        top: continuationTop,
                        right: marginRight,
                        bottom: 16,
                        left: marginLeft,
                    },
                    head: this.getPdfSummaryTableHead(),
                    body: this.kardexSummaryRowsForPdf,
                    theme: 'grid',
                    tableWidth: 95,
                    styles: {
                        fontSize: 7.5,
                        cellPadding: 1.6,
                        textColor: [15, 23, 42],
                        lineColor: [90, 90, 90],
                        lineWidth: 0.05,
                        valign: 'middle',
                    },
                    headStyles: {
                        fillColor: false,
                        textColor: [15, 23, 42],
                        lineColor: [90, 90, 90],
                        fontStyle: 'bold',
                    },
                    columnStyles: {
                        0: { cellWidth: 58 },
                        1: { cellWidth: 37, halign: 'right' },
                    },
                    didParseCell: (data) => {
                        if (data.section === 'body') {
                            const label = data.row.raw?.[0] || '';
                            if (this.isHighlightedPdfSummaryRow(label)) {
                                data.cell.styles.fontStyle = 'bold';
                            }
                        }
                    },
                });
            }

            this.drawGeneralPdfHeader(doc, {
                companyName,
                pageWidth,
                marginLeft,
                marginRight,
                dateStart,
                dateEnd,
                generatedAt,
            });
            this.addPdfFooters(doc, companyName, generatedAt);

            doc.save(`KARDEX General (${this.formatFileDate(this.columsConfig[0].value)} al ${this.formatFileDate(this.columsConfig[1].value)}).pdf`);
        },
        async exportPdfReport() {
            await this.exportPdfDetailedReport();
        },
        async onExportPdfClick() {
            this.loading = true;

            try {
                await this.waitForLoadingOverlay();
                await this.exportPdfReport();
            } catch (error) {
                console.error('Error durante la exportación a PDF:', error);
            } finally {
                this.loading = false;
            }
        },
        onExporting(e) {
            const dateStart = this.formatFileDate(this.columsConfig[0].value);
            const dateEnd = this.formatFileDate(this.columsConfig[1].value);
            printToExcel(e, `KARDEX General (${dateStart} al ${dateEnd})`, null, "", 'KARDEX General');
        },
    }
}
</script>

<style scoped>
.background {
    background: white !important;
    color: white;
}

/* Mejoras de responsividad para el contenedor */
.versatile-filter-container {
    width: 100%;
    padding: 10px;
    overflow-x: hidden;
}

.kardex-summary-panels {
    background: transparent !important;
}

.kardex-summary-panel__header {
    border: 1px solid #dbe2ea;
    border-radius: 12px;
    background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
}

.kardex-summary-panel__actions {
    display: flex;
    align-items: center;
    gap: 10px;
}

.kardex-summary-panel__export-btn {
    flex-shrink: 0;
}

.kardex-summary-panel__chevron {
    flex-shrink: 0;
}

.kardex-summary {
    padding: 8px 2px 0;
}

.kardex-summary__title {
    color: #0f172a;
    font-size: 16px;
    font-weight: 700;
}

.kardex-summary__subtitle {
    color: #64748b;
    font-size: 13px;
}

.kardex-summary-grid {
    margin-top: 0;
}

.kardex-summary-grid__col {
    padding: 10px !important;
}

.kardex-summary-card {
    height: 100%;
    min-height: 104px;
    padding: 14px 16px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #ffffff;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.kardex-summary-card__label {
    color: #475569;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
}

.kardex-summary-card__value {
    margin-top: 10px;
    color: #0f172a;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.1;
}

.kardex-summary-card__secondary {
    margin-top: 8px;
    color: #64748b;
    font-size: 13px;
    font-weight: 500;
}

/* Media queries para dispositivos móviles */
@media (max-width: 600px) {
    .v-radio-group {
        margin: 8px 12px !important;
    }

    .v-radio-group .v-radio {
        margin-bottom: 4px;
    }

    .v-tabs .v-tab {
        font-size: 0.875rem;
        padding: 0 8px;
    }

    .versatile-filter-container {
        padding: 0 4px;
    }

    .kardex-summary {
        padding: 6px 0 0;
    }

    .kardex-summary-card {
        min-height: 92px;
    }

    .kardex-summary-card__value {
        font-size: 20px;
    }

    .kardex-summary-panel__actions {
        gap: 6px;
    }

    .kardex-summary-panel__export-btn {
        padding-left: 10px !important;
        padding-right: 10px !important;
        min-width: auto !important;
    }
}

@media (max-width: 960px) and (min-width: 601px) {
    .v-radio-group {
        margin: 12px 16px !important;
    }

    .v-tabs .v-tab {
        font-size: 0.9rem;
    }
}
</style>

<style>
.kardex-group-header {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 12px 16px;
    font-size: 15px;
    font-weight: 500;
    color: #334155;
    text-align: center;
    align-items: center;
}

.kardex-group-header__line {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    justify-content: center;
}

.kardex-group-header__label {
    font-weight: 700;
    color: #0f172a;
}

.dx-datagrid-rowsview .dx-group-row > td {
    background: #f8fafc !important;
    border-top: 1px solid #dbe2ea;
    border-bottom: 1px solid #dbe2ea;
    white-space: normal;
}

.dx-datagrid-rowsview .dx-row.dx-group-row td {
    font-size: 14px;
}
</style>
